@if (href) {
  <a [attr.href]="href">
    <ng-container *ngTemplateOutlet="icon"></ng-container>
  </a>
} @else {
  <ng-container *ngTemplateOutlet="icon"></ng-container>
}

<ng-template #icon>
  <div
    data-qa="icon"
    class="flex flex-row items-center justify-center icon-size-1 {{styling}} {{inputStyling}}"
    [id]="buttonTooltip?.id"
    (mouseenter)="activateTooltip()"
    (mouseleave)="showTooltip = false">
    @if (iconName) {
      <svg data-qa="all-icons-svg">
        <use [attr.xlink:href]="folderPath + iconName + '#img'" [attr.href]="folderPath + iconName + '#img'">
        </use>
      </svg>
    }
  </div>
</ng-template>

@if (showTooltip) {
  <app-tooltip
    [coordinates]="tooltipCoordinates"
    [title]="buttonTooltip.text"
    [xShift]="buttonTooltip.xShift"
  />
}
